import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';
import { AssigneeFilter, DEFAULT_FILTER_VALUES, SelectedFilters } from '@frontend/task-center-scope';

type TaskCenterFiltersStore = AssigneeFilter & {
  selectedFilters: SelectedFilters;
  setSelectedFilters: (values: SelectedFilters) => void;
  resetFilters: () => void;
  resetCreator: () => void;
  resetSelectedFilters: () => void;
};

export const useTaskCenterFilters = createShallowStore(
  createStoreWithPersistAndSubscribe<TaskCenterFiltersStore>(
    (set) => {
      return {
        selectedFilters: DEFAULT_FILTER_VALUES,
        assigneeFilter: '',
        setAssigneeFilter: (value: string) => set({ assigneeFilter: value }),
        setSelectedFilters: (values: SelectedFilters) => set({ selectedFilters: values }),
        resetCreator: () =>
          set((state) => ({ selectedFilters: { ...state.selectedFilters, creator: DEFAULT_FILTER_VALUES.creator } })),
        resetFilters: () => set({ selectedFilters: { ...DEFAULT_FILTER_VALUES }, assigneeFilter: '' }),
        resetSelectedFilters: () => set({ selectedFilters: { ...DEFAULT_FILTER_VALUES } }),
      };
    },
    { name: 'task-center-filters-store' },
    { name: 'task-center-filters-store', trace: true }
  )
);
